import React, {useEffect, useRef, useState} from "react";
import { connect } from 'react-redux';
import {IconButton, Tooltip, Typography, withStyles} from '@material-ui/core';
import {hasPermission, createHistory } from "../../sc-utilities";
import SecurazeSolutionList from "./SecurazeSolutionList";
import {FindInPage} from "@material-ui/icons";
import {Redirect} from "react-router-dom";
import * as actions from '../ErasureMethod/store/erasureMethodActions';

const styles = (theme) => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
        padding: 0,
            margin: 0,
            width: '100%'
        }
    }
})

const SecurazeSolution = (props) => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions, activeCustomerID, onListSupportedClientTypes } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, redirectPath: '' });
    const visible = columns && columns['SecurazeSolutions'];
    const [supportedClientTypes, setSupportedClientTypes] = useState(null);

    useEffect(() => {
        const fetchSupportedClientTypes = async () => {
            let supportedClientTypes = await onListSupportedClientTypes({ActiveCustomerID: activeCustomerID});
            let formattedSupportedClientTypes = supportedClientTypes.reduce(
                (obj, item) => Object.assign(obj, { [item.value]: item.label }), {});
            setSupportedClientTypes(formattedSupportedClientTypes);
        };
        fetchSupportedClientTypes();
    }, [activeCustomerID, onListSupportedClientTypes]);

    const redirectHandler = (path) => {
        createHistory();
        setRedirectOptions({ redirect: true, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const tableColumns = [
        {
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {hasPermission(permissions, 'securaze_solution_load') ?
                    <Tooltip key={`securaze_solution_details`} title={translations["securaze_solution_details"] || "Securaze Solution details"}>
                        <IconButton
                            id={`securaze_solution_details`}
                            component='div'
                            onClick={(event) => redirectHandler(`/admin/securaze-solution/edit?SecurazeSolutionID=${rowData.SecurazeSolutionID}`)}> 
                            <FindInPage />
                        </IconButton>
                    </Tooltip>
                    : null
                }
            </>
        },
        {
            title: translations["key"] || 'Key', field: 'Key',
            hidden: visible ? visible['Key'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Key?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
        {
            title: translations["long_name"] || 'Long name', field: 'LongName',
            hidden: visible ? visible['LongName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.LongName?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
        {
            title: translations["short_name"] || 'Short name', field: 'ShortName',
            hidden: visible ? visible['ShortName'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ShortName?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
        {
            title: translations["dedicated_for"] || 'Dedicated for', field: 'DedicatedFor',
            hidden: visible ? visible['DedicatedFor'] : false,
            filtering: true,
            lookup: {'All': translations['all'] || 'All', 'Magnetic': translations['magnetic'] || 'Magnetic', 'Flash': translations['flash'] || 'Flash'},
            defaultFilter: ['All', 'Magnetic', 'Flash'],
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.DedicatedFor?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
        {
            title: translations["description"] || 'Description', field: 'Description',
            hidden: visible ? visible['Description'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Description?? (translations['short_not_assigned'] || 'n/a')}</Typography>;
            }
        },
        {
            title: translations["supported_client_types"] || 'SupportedClientTypes', field: 'SupportedClientTypes',
            hidden: visible ? visible['SupportedClientTypes'] : false,
            filtering: true,
            filterCellStyle: { maxWidth: '150px' },
            lookup: supportedClientTypes,
            defaultFilter: [],
            render: rowData => {
                return rowData.SupportedClientTypes.length > 0 ? rowData.SupportedClientTypes.slice(0, 3).map((supportedClientType, index) => {
                    return <Typography key={supportedClientType.SupportedClientTypeID} variant={'caption'}>{supportedClientType.Name}{index !== 2 ? <br /> : '...'}</Typography>;
                }) : <Typography variant={'caption'}> n/a </Typography>;
            }
        },
    ]

    return (
        <div className={classes.root}>
            {hasPermission(permissions, "securaze_solution_list") && supportedClientTypes ?
            <SecurazeSolutionList
                tableRef={tableRef}
                tableColumns={tableColumns}
                redirectHandler={redirectHandler}
            /> : null}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onListSupportedClientTypes: (data, option) => dispatch(actions.listSupportedClientTypes(data, option)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(SecurazeSolution));